/**
 * Defence in depth for the preview: the server renders company text escaped, but strip
 * script-capable markup before srcDoc anyway so the browser does not attempt module/classic script loads (console MIME errors).
 * Real outbound email is rendered server-side; preview is visual-only.
 */
export function sanitizeEmailPreviewHtmlForIframe(html: string): string {
  const trimmed = html?.trim() ?? ''
  if (!trimmed) return ''

  try {
    const doc = new DOMParser().parseFromString(trimmed, 'text/html')

    doc.querySelectorAll('script').forEach((el) => el.remove())

    doc.querySelectorAll('link[rel="modulepreload"], link[rel="preload"][as="script"]').forEach((el) => el.remove())

    doc.querySelectorAll('*').forEach((el) => {
      for (const { name, value } of [...el.attributes]) {
        const lower = name.toLowerCase()
        if (lower.startsWith('on')) {
          el.removeAttribute(name)
          continue
        }
        if ((lower === 'href' || lower === 'src') && /^\s*javascript:/i.test(value)) {
          el.removeAttribute(name)
        }
      }
    })

    return doc.documentElement ? doc.documentElement.outerHTML : trimmed
  } catch {
    return trimmed
  }
}
